import axios from "axios"
import Urls from "../endpoints";
import { ICancelCustomerFreePackage } from "../resultAPI/cancelCustomerFreePackageResult";


export const cancelFreeIvrPackage = (id: string) => {
    return axios.post<ICancelCustomerFreePackage>(Urls.cancelCustomerFreeIvrPackage(id))
}


export const cancelFreeSecretaryPackage = (id: string) => {
    return axios.post<ICancelCustomerFreePackage>(Urls.cancelCustomerFreeSecretaryPackage(id))
}


